<ng-content select="app-feature-title"></ng-content>
<div class="feature-content-container">
  <ng-content select="app-feature-subtitle"></ng-content>
  <ng-content></ng-content>
</div>
